<template>
  <div id="app">
    <template>
      <app-header v-show="routerName!='onlinetest' && routerName!='viewAnswer'"></app-header>
    </template>
    <router-view :key="$route.fullPath" />
    <template>
      <app-footer v-show="routerName!='onlinetest' && routerName!='viewAnswer'"></app-footer>
    </template>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import './assets/css/common.css'
export default {
  name: 'App',
  components:{
    'app-header':Header,
    'app-footer':Footer
  },
  data (){
    return {
      routerName:''
    }
  },
  watch:{
    '$route' (to, from) {
       // data数据操作
       console.log(to)
       this.routerName=to.name;
     }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue